import React from 'react';
export default function Services() {
  const services = [
    {
      title: 'Mobile App Development (Android & iOS)',
      icon: '📱',
      subtitle: 'Modern Mobile Experiences',
      description:
        'Build powerful Android and iOS mobile applications with modern UI/UX, high performance, and scalable architecture.',
      features: [
        'React Native',
        'Flutter Apps',
        'Android Apps',
        'iOS Apps'
      ],
      additional:
        'Our mobile applications are designed with modern UI/UX principles to deliver smooth performance, secure functionality, and seamless experiences across Android and iOS platforms.'
    },
    {
      title: 'Matrimonial Services Platform',
      icon: '💍',
      subtitle: 'Modern Matchmaking Digital Solutions',
      description:
        'We develop advanced matrimonial websites and mobile applications with secure profile management, smart matching systems, premium memberships, and modern responsive user experience.',
      features: [
        'Profile Management',
        'Smart Matchmaking',
        'Membership Plans',
        'Secure Communication'
      ],
      additional:
        'Our matrimonial platform solutions are designed for communities, organizations, and businesses looking to build secure and scalable matchmaking systems with modern UI/UX and powerful admin management features.'
    },
    {
      title: 'Website & E-Commerce Solution',
      icon: '🌐',
      subtitle: 'Professional Online Presence',
      description:
        'Modern websites and ecommerce platforms designed for better user engagement, online sales, and business growth.',
      features: [
        'Responsive Design',
        'Payment Gateway',
        'SEO Friendly',
        'Admin Dashboard'
      ],
      additional:
        'We create high-performance websites and ecommerce solutions that improve online visibility, customer engagement, and business sales with modern responsive designs.'
    },
    {
      title: 'Enterprise Resource Planning - ERP',
      icon: '📊',
      subtitle: 'Plan. Execute. Deliver — Projects Done Right',
      description:
        'Enterprise Resource Planning (ERP) is a comprehensive software solution that integrates all key business functions into a single centralized system. From finance, inventory, HR, procurement, sales, and customer management, ERP improves operational efficiency and business productivity.',
      features: [
        'Finance Management',
        'Inventory Control',
        'HR Management',
        'Project Tracking'
      ],
      additional:
        'Our ERP solutions are designed to simplify complex workflows, reduce manual effort, and provide real-time insights for smarter decision-making. Whether you are a startup or a large enterprise, we build scalable ERP systems tailored to your business operations and future growth.'
    },
    {
      title: 'Enterprise Cloud Solutions',
      icon: '☁️',
      subtitle: 'Secure. Scalable. Reliable Cloud Services',
      description:
        'Cloud solutions help businesses manage infrastructure, applications, hosting, and data securely with high scalability and flexibility for modern digital transformation.',
      features: [
        'Cloud Hosting',
        'AWS Services',
        'Server Management',
        'Data Security'
      ],
      additional:
        'Our cloud solutions help businesses improve scalability, ensure secure data storage, and optimize infrastructure performance with modern cloud technologies and managed hosting services.'
    },
    {
      title: 'Customer Relationship Management - CRM',
      icon: '🤝',
      subtitle: 'Manage Customers Better',
      description:
        'CRM solutions streamline customer communication, sales management, support systems, and lead tracking to improve business relationships and customer satisfaction.',
      features: [
        'Lead Management',
        'Sales Tracking',
        'Customer Support',
        'Analytics'
      ],
      additional:
        'CRM platforms improve customer engagement, automate communication, and provide valuable customer insights to strengthen long-term business relationships and increase sales productivity.'
    },
    {
      title: 'Custom Software Development',
      icon: '⚙️',
      subtitle: 'Tailor-Made Business Solutions',
      description:
        'We develop scalable and customized software applications based on your unique business workflow and operational requirements.',
      features: [
        'ERP Solutions',
        'Automation',
        'Business Apps',
        'Custom Workflows'
      ],
      additional:
        'We build custom software applications tailored to your operational workflow, helping businesses automate processes, improve productivity, and achieve digital transformation efficiently.'
    },
    {
      title: 'Digital Marketing',
      icon: '📈',
      subtitle: 'Grow Your Brand Digitally',
      description:
        'Digital marketing services including SEO, social media management, branding, and advertising strategies to grow your business online.',
      features: [
        'SEO',
        'Social Media',
        'Google Ads',
        'Brand Promotion'
      ],
      additional:
        'Our digital marketing strategies help businesses improve brand awareness, generate quality leads, and achieve better online visibility through targeted campaigns.'
    },
    {
      title: 'Project Planning & Management',
      icon: '📋',
      subtitle: 'Efficient Project Execution',
      description:
        'Project planning and management services ensure smooth workflow, resource allocation, tracking, and timely delivery.',
      features: [
        'Task Management',
        'Resource Planning',
        'Progress Tracking',
        'Team Collaboration'
      ],
      additional:
        'We provide structured project planning and management solutions to improve coordination, optimize resources, and ensure successful project execution within timelines.'
    },
    {
      title: 'IOT (Internet Of Things)',
      icon: '📡',
      subtitle: 'Smart Connected Systems',
      description:
        'IoT solutions connect devices and systems for smart automation, monitoring, and real-time data processing.',
      features: [
        'Smart Devices',
        'Automation',
        'Monitoring Systems',
        'Real-Time Data'
      ],
      additional:
        'IoT technologies connect smart devices and systems to enable automation, real-time monitoring, predictive analytics, and intelligent decision-making for businesses.'
    },
    {
      title: 'Business Consultancy Services',
      icon: '💼',
      subtitle: 'Technology & Growth Consulting',
      description:
        'Expert business consultancy services to help organizations improve operations, adopt technology, and achieve sustainable growth.',
      features: [
        'Business Strategy',
        'IT Consulting',
        'Digital Transformation',
        'Process Optimization'
      ],
      additional:
        'Our consultancy services help businesses adopt the right technologies, improve operational efficiency, and implement strategies for long-term growth and digital success.'
    }
  ];

  const [activeService, setActiveService] = React.useState(services[0]);

  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="uppercase tracking-[3px] text-[#0a8082] font-semibold mb-4">
            Our Services
          </p>

          <h2 className="text-5xl font-bold text-[#071E56] mb-6">
            Smart Digital Solutions
          </h2>

          <p className="text-gray-600 text-lg leading-8 max-w-4xl mx-auto">
            Innovative software solutions and digital services designed to help businesses grow faster and smarter.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-6 lg:gap-10 items-start">
          <div className="bg-[#d9edf5] rounded-[30px] p-4 sm:p-6 lg:p-8 lg:sticky lg:top-28 shadow-lg">
            <h3 className="text-2xl sm:text-3xl font-bold text-[#071E56] mb-6 lg:mb-8">
              Our Services
            </h3>

            <div className="space-y-5">
              {services.map((service, index) => (
                <button
                  key={index}
                  onClick={() => setActiveService(service)}
                  className={`w-full flex items-start sm:items-center justify-between rounded-2xl px-4 sm:px-6 py-4 sm:py-5 text-left font-semibold transition duration-300 ${
                    activeService.title === service.title
                      ? 'bg-gradient-to-r from-[#0a8082] to-[#071E56] text-white shadow-xl'
                      : 'bg-white text-[#071E56] hover:bg-[#0a8082] hover:text-white shadow-md'
                  }`}
                >
                  <div className="flex items-start sm:items-center gap-3 sm:gap-4 text-sm sm:text-lg leading-6">
                    <span className="text-2xl">{service.icon}</span>
                    <span>{service.title}</span>
                  </div>

                  <span className="text-xl sm:text-2xl shrink-0">↗</span>
                </button>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#071E56] mb-4 sm:mb-6 leading-tight">
              {activeService.title}
            </h2>

            <p className="text-lg sm:text-xl lg:text-2xl font-semibold text-[#0a8082] mb-6 sm:mb-8 leading-8">
              {activeService.subtitle}
            </p>

            <div className="bg-gradient-to-r from-[#0a8082] to-[#071E56] rounded-[25px] sm:rounded-[35px] p-3 sm:p-6 shadow-2xl">
              <div className="bg-white rounded-[22px] sm:rounded-[28px] p-5 sm:p-8 lg:p-10">
                <div className="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 rounded-[24px] sm:rounded-[30px] bg-gradient-to-r from-[#0a8082] to-[#071E56] text-white flex items-center justify-center text-5xl sm:text-6xl lg:text-7xl mx-auto mb-6 sm:mb-10 shadow-2xl">
                  {activeService.icon}
                </div>

                <p className="text-gray-600 text-base sm:text-lg leading-8 sm:leading-10 text-justify mb-6 sm:mb-10">
                  {activeService.description}
                </p>

                <div className="bg-[#f7fbfc] border border-gray-100 rounded-3xl p-5 sm:p-8 mb-6 sm:mb-10">
                  <h3 className="text-3xl font-bold text-[#071E56] mb-5">
                    Why Choose This Service?
                  </h3>

                  <p className="text-gray-600 text-lg leading-9 text-justify">
                    {activeService.additional}
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                  {activeService.features.map((feature, idx) => (
                    <div
                      key={idx}
                      className="bg-gray-50 border border-gray-100 rounded-2xl px-4 sm:px-6 py-4 sm:py-5 flex items-center gap-3 sm:gap-4 shadow-sm"
                    >
                      <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-[#0a8082] to-[#071E56] text-white flex items-center justify-center text-xl">
                        ✓
                      </div>

                      <span className="font-semibold text-[#071E56] text-sm sm:text-lg leading-6">
                        {feature}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}